import ajax from 'api/ajax'
// 试剂柜设置
class cabinetSet {
    // 获取智能称管理列表
    getSmartList = ( per_page, page ) => ajax('dict-equip/search',{'per-page':per_page, page}, 'get')
    // 获取智能称编辑列表
    getSmartDdtail= (seqno) => ajax('dict-equip/view',{seqno}, 'get')
    //  智能称管理表单提交
    SmartCreate =
        (   COMMENTS,
            EQUIP_BATCH_NO,
            EQUIP_ID,
            ONLINE_STATUS,
            SEQ_NO,
            SIM_ID,
        )=> ajax('dict-equip/update',
            {
                COMMENTS,
                EQUIP_BATCH_NO,
                EQUIP_ID,
                ONLINE_STATUS,
                SEQ_NO,
                SIM_ID,
            }, 'post')
    //  获取试剂柜管理
    getCabinetList = ( per_page, page ) => ajax('dict-cabinet/search',{'per-page':per_page, page}, 'get')
    // 获取试剂柜编辑列表
    getCabinetDetail= (seqno) => ajax('dict-cabinet/view',{seqno}, 'get')
    //  试剂柜管理表单提交新增
    CabinetCreate =
        (   CABINETTYPE,
            CABINET_ID,
            CABITYPE_ID,
            COMMENTS,
            EQUIP_ID,
            HUMIDITY,
            ONLINE_STATUS,
            TEMPERATURE
        // )=> ajax('/api/dict-cabinet/update',
        )=> ajax('dict-cabinet/create',
            {
                CABINETTYPE,
                CABINET_ID,
                CABITYPE_ID,
                COMMENTS,
                EQUIP_ID,
                HUMIDITY,
                ONLINE_STATUS,
                TEMPERATURE
            }, 'post')
    //  试剂柜管理表单提交编辑
    CabinetUpdate =
        (   CABINETTYPE,
            CABINET_ID,
            CABITYPE_ID,
            COMMENTS,
            EQUIP_ID,
            HUMIDITY,
            ONLINE_STATUS,
            SEQ_NO,
            TEMPERATURE
            )=> ajax('dict-cabinet/update',
            {
                CABINETTYPE,
                CABINET_ID,
                CABITYPE_ID,
                COMMENTS,
                EQUIP_ID,
                HUMIDITY,
                ONLINE_STATUS,
                SEQ_NO,
                TEMPERATURE
            }, 'post')
//     获取柜子类型字典
    getCabinet = ( per_page, page ,list) => ajax('cabi-dict-cabitype',{'per-page':per_page, page,list}, 'get')
//    获取智能称 字典
    getSmall = ( per_page, page ,list) => ajax('dict-equip/search',{'per-page':per_page, page,list}, 'get')
//    删除试剂柜信息
    deleteCabinet= (SEQ_NO) => ajax('dict-cabinet/delete',{SEQ_NO}, 'post')
//    获取人员信息
    getPeopleList=(cabinetid,equipid,list='all')=> ajax('cabi-right/getusers',{cabinetid,equipid,list}, 'get')
// 删除人员
    deletePeople = (CARD_NO,CABINET_ID,EQUIP_ID)=> ajax('cabi-right/delete',{CARD_NO,CABINET_ID,EQUIP_ID}, 'post')
//    增加人员
    addpeople = (CARD_NO,CABINET_ID,EQUIP_ID)=> ajax('cabi-right/create',{CARD_NO,CABINET_ID,EQUIP_ID}, 'post')


}

export default cabinetSet
